import { useSelector } from 'react-redux';
import AccionaResidualImpactProbElement from './AccionaResidualImpactProbElement';

const AccionaResidualImpactProbBlock = (props) => {
  const { plantObligation } = props;
  const poLevel3 = useSelector(
    (state) => state.currentPage?.plantObligationLevels?.level3
  );

  return (
    <>
      <div>
        <AccionaResidualImpactProbElement
          type="imp"
          state={poLevel3?.[plantObligation]?.accionaPenaltyRisk?.residualImpact}
        />
      </div>
      <div>
        <AccionaResidualImpactProbElement type="prob" state={poLevel3?.[plantObligation]?.accionaPenaltyRisk?.residualProbability} />
      </div>
    </>
  );
};
export default AccionaResidualImpactProbBlock;
